import { OnboardingDto } from '../../interfaces/Dto/OnboardingDto';

export function transformResponse(response: OnboardingDto): OnboardingDto {
  const responseData = response?.data;

  let isTimeExceeded = false;
  const mfaConfirmationTime = sessionStorage.getItem('mfaConfirmationTime');
  if (mfaConfirmationTime) {
    const maxAllowedTime = new Date(mfaConfirmationTime);
    maxAllowedTime.setMinutes(maxAllowedTime.getMinutes() + 10);

    isTimeExceeded = new Date() > maxAllowedTime;
  }

  if (mfaConfirmationTime && responseData?.onboardingStatus === 'active' && !isTimeExceeded) {
    responseData.onboardingStatus = 'completed';
  }

  return { data: responseData };
}
